module.exports = __webpack_public_path__ + "pc/img/06_Strategy-Planning.ee370c5d.png";